/** get data from OBI
 * @param {string} portName - name of the port
 * @param {object} boxDetails - complete box object
 * @param {string} key - value to be extracted from obi object
 * @returns {string | object} - returns key value if provided or complete box object
 */
const getAtaData = (portName, boxDetails, key) => {
  const portSelected = portName?.split(' ');
  const obiIndex = portSelected && Math.round((parseInt(portSelected[1]) + 0.5) / 2);
  if (key && portSelected) {
    if (key === 'portName') {
      portSelected[1] = obiIndex;
      return portSelected?.join('').toLowerCase();
    }
    if (key === 'portIndex') return obiIndex;
    return boxDetails?.externalAta?.length === 1
      ? boxDetails?.externalAta[0][key]
      : boxDetails?.externalAta[obiIndex - 1][key];
  }
  return boxDetails?.externalAta?.length === 1
    ? boxDetails?.externalAta[0]
    : boxDetails?.externalAta[obiIndex - 1];
};

export default getAtaData;
